import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';
import { useState } from 'react';

import { CardPreview } from '@/components/CardPreview';
import type {
    CardsCustomization,
    ChargingCardCustomizationSchemaType,
    ChargingCardsSchemaType,
} from '@/components/steps/ChargingCardsStep';
import SummaryStepSection from '@/components/steps/SummaryStep/SummaryStepSection';
import { t } from '@/lib/utils';

export type SummaryStepCustomizedCardProps = {
    cardIndex: number;
    customizedCard: ChargingCardCustomizationSchemaType;
};
const SummaryStepCustomizedCard = ({ cardIndex, customizedCard }: SummaryStepCustomizedCardProps) => (
    <div key={cardIndex}>
        <span className='text-bold'>{`${t('onboarding.card')} ${cardIndex + 1}`}</span>
        <div className='margin-top-10'>
            <CardPreview line1={customizedCard.line1} line2={customizedCard.line2} showDefaultText={false} />
        </div>
    </div>
);

export type SummaryStepCardsSectionProps = {
    goToPage: (stepNumber: number) => void;
    chargingCardsState: ChargingCardsSchemaType;
    className?: string;
};

const checkCustomization = (list?: CardsCustomization[]): boolean =>
    list?.some(({ line1, line2 }) => line1 || line2) ?? false;

export const SummaryStepCardsSection = ({
    chargingCardsState,
    goToPage,
    className = '',
}: SummaryStepCardsSectionProps) => {
    const [isCardsCustomisationOpen, setCardsCustomisationOpen] = useState(false);
    const { cardsListCustomization } = chargingCardsState;
    const hasCustomizations = checkCustomization(cardsListCustomization);
    return (
        <SummaryStepSection
            className={className}
            innerClassName='flex-basis-100pct'
            title={t('general.chargingCards')}
            goToFunction={() => goToPage(0)}
        >
            <div className='padding-bottom-5'>
                {`${t('onboarding.numberOfChargingCards')}: `}
                <strong>{chargingCardsState.cardsNumber}</strong>
            </div>
            <div className={`${hasCustomizations ? 'padding-bottom-5' : ''}`}>
                {`${t('onboarding.chargingCardCustomisation')}: `}
                <strong>{`${hasCustomizations ? t('general.yes') : t('general.no')}`}</strong>
            </div>
            {hasCustomizations && (
                <ExpanderPanel
                    bodyClassName='padding-0'
                    open={isCardsCustomisationOpen}
                    title={t('general.orderChargingCard.preview')}
                    onToggle={setCardsCustomisationOpen}
                    className='border-color-light margin-top-5'
                >
                    <div className='display-grid grid-cols-4 width-100pct bg-lighter rounded-bottom padding-20 gap-20'>
                        {cardsListCustomization?.map((customizedCard, cardIndex) => (
                            <SummaryStepCustomizedCard
                                key={cardIndex}
                                cardIndex={cardIndex}
                                customizedCard={customizedCard}
                            />
                        ))}
                    </div>
                </ExpanderPanel>
            )}
        </SummaryStepSection>
    );
};
